module.exports = __webpack_public_path__ + "coin_XBI.png?278ae07c02293b63f20278738d1832f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_XBI.png
// module id = 1123
// module chunks = 2